import React, { useState } from 'react';
import { Card, CardContent, Typography, Grid, TextField, Box, Button, useScrollTrigger, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Divider } from '@mui/material';
import { useForm } from 'react-hook-form';
import { IconFingerprint, IconCheck, IconCircleCheck, IconX, IconAlertTriangle } from '@tabler/icons-react';
import PageContainer from '../MainPages/PageContainer';
import Breadcrumb from '../MainPages/Breadcrumb';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Billing = () => {
  const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, clearErrors: clearErrors1, reset: reset1, getValues: getValues1, trigger: trigger1 } = useForm();
  const { register, handleSubmit, formState: { errors }, clearErrors, reset, getValues, trigger } = useForm();
  const NameOnCard = getValues1("nameOnCard")
  const CardNumber = getValues1("cardNumber")
  const Cvv = getValues1("cvv")
  const Expire = getValues1("expirationDate")
  const params = new URLSearchParams(window.location.search);
  // const SelectedPlan = params.get("plan")
  // const SelectedPlanid = params.get("planid")
  // const Currentplanid = params.get("currentplanid")
  // const Price = params.get("price")
  // const PlanType = params.get("isrenewal")
    const planid = params.get("id");
    const selectedPlan = params.get("selectedplanid");
    const Type = params.get('type')
    const CurrentPlanid = params.get("currentplanid");
  const [successpopup, setsuccesspopup] = useState(false)
  const userInfo = JSON.parse(sessionStorage.getItem('user-info'))
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [Errorpopup,setErrorpopup]=useState(false)
  const [ErrorMessage,setErrorMessage]=useState('')
  const onSubmitBilling = async (data) => {
    setLoader(true)
    let req =
    {
      card_number: data.cardNumber,
      expiry_date: data.expirationDate,
      cvv_code: data.cvv,
      description: data.description,
      email: userInfo?.email,
      address: data.address,
      city: data.City,
      state: data.state,
      zip: data.postalCode,
      country: data.country,
      user_id: userInfo.id,
      selected_plan_id: selectedPlan,
      // user_current_subscription_id: Currentplanid !== "undefined" ? Currentplanid : null,
      order_id:planid,
      type: Type,
      current_subscription_id: CurrentPlanid,
    }
    try {
      const response = await axios.post('/apiV1/upgrade-subscription/', req)
      if (response.status === 200) {
        console.log(response.data);
        setsuccesspopup(true)
      }
    } catch (err) {
      console.log(err);
      setLoader(false)
      setErrorpopup(true)
      setErrorMessage(err.response.data.message)
    }
  }

  const onSubmit = (data) => {
    console.log('Payment Data:', data);
    alert('Payment Details saved successfully!');
  };
  const BCrumb = [
    {
      to: '/plans',
      title: 'Plans',
    }
  ];
  return (
    <>
      <PageContainer title="BA Tool | Billing">
        <Breadcrumb breadcrumbs={BCrumb} />
        <Card
          sx={{
            padding: 4,
            margin: "30px 0px 0px 0px",
            boxShadow: 3,
          }}
        >
          {/* <Typography sx={{ ml: 2, fontSize: 20 }}>Selected Plan : {SelectedPlan}</Typography> */}
          <CardContent>
            <form onSubmit={handleSubmit1(onSubmitBilling)}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} sx={{ p: 2 }}>
                  <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ marginBottom: 2, padding: 2, fontWeight: 550 }}>
                      Billing Information
                    </Typography>
                    <Grid container spacing={3} sx={{ p: 3 }}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Name"
                          placeholder="Jordan Smith"
                          {...register1('name')}
                          error={!!errors1.name}
                          helperText={errors1.name ? errors1.name.message : ''}
                          disabled={loader}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Email Address"
                          placeholder="jordansmith@mail.com"
                          {...register1('email')}
                          value={userInfo?.email}
                          error={!!errors1.email}
                          disabled={true}
                          helperText={errors1.email ? errors1.email.message : ''}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Phone Number"
                          {...register1('phone', {
                            required: 'Phone number is required',
                            pattern: {
                              value: /^[0-9]{10,12}$/,
                              message: 'Invalid phone number format',
                            },
                          })}
                          error={!!errors1.phone}
                          helperText={errors1.phone ? errors1.phone.message : ''}
                          disabled={loader}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Country"
                          placeholder="Country"
                          {...register1('country', {
                            required: 'Country is required',
                          })}
                          error={!!errors1.country}
                          disabled={loader}
                          helperText={errors1.country ? errors1.country.message : ''}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="State"
                          placeholder="State"
                          {...register1('state', {
                            required: 'State is required',
                          })}
                          error={!!errors1.state}
                          disabled={loader}
                          helperText={errors1.state ? errors1.state.message : ''}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="City"
                          placeholder="City"
                          {...register1('City', {
                            required: 'City is required',
                          })}
                          error={!!errors1.City}
                          disabled={loader}
                          helperText={errors1.City ? errors1.City.message : ''}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Address"
                          placeholder="123 Main St"
                          {...register1('address', {
                            required: 'Address is required',
                          })}
                          error={!!errors1.address}
                          disabled={loader}
                          helperText={errors1.address ? errors1.address.message : ''}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Postal Code"
                          placeholder="12345"
                          {...register1('postalCode', {
                            required: 'Postal code is required',
                            pattern: {
                              value: /^\d{6,8}$/,
                              message: 'Postal code must be between 6 and 8 digits',
                            },
                          })}
                          error={!!errors1.postalCode}
                          disabled={loader}
                          helperText={errors1.postalCode ? errors1.postalCode.message : ''}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          fullWidth
                          label="Description"
                          placeholder="Enter Description"
                          {...register1('description', {
                            required: 'Description is required',
                          })}
                          error={!!errors1.description}
                          disabled={loader}
                          helperText={errors1.description ? errors1.description.message : ''}
                        />
                      </Grid>
                    </Grid>
                    {/* <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        m: 2,
                        gap: 2,
                      }}
                    >
                      <Button variant="outlined" color="inherit" onClick={() => reset1()} sx={{ backgroundColor: "crimson" }}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        type="submit"
                        color='primary'
                      >
                        Save
                      </Button>
                    </Box> */}
                  </Card>
                </Grid>

                <Grid item xs={12} md={6} sx={{ p: 3 }}>
                  <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ marginBottom: 2, padding: 2, fontWeight: 550 }}>
                      Payment Details
                    </Typography>
                    <Grid container spacing={3} sx={{ p: 3 }}>
                      {/* Name on Card */}
                      {/* <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Name on Card"
                          placeholder="Jordan Smith"
                          {...register1("nameOnCard", {
                            required: "Name is required",
                            pattern: {
                              value: /^[A-Za-z\s]+$/,
                              message: "Name must contain only letters",
                            },
                          })}
                          error={!!errors1.nameOnCard}
                          helperText={errors1.nameOnCard?.message}
                          onKeyUp={() => trigger1("nameOnCard")}
                        />
                      </Grid> */}

                      {/* Card Number */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Card Number"
                          placeholder="1234 1234 1234 1234"
                          {...register1("cardNumber", {
                            required: "Card number is required",
                            pattern: {
                              value: /^\d{16}$/,
                              message: "Card number must be 16 digits",
                            },
                          })}
                          error={!!errors1.cardNumber}
                          helperText={errors1.cardNumber?.message}
                          onKeyUp={() => trigger1("cardNumber")}
                          disabled={loader}
                          inputProps={{ maxLength: 16 }}
                        />
                      </Grid>

                      {/* Expiration Date */}
                      <Grid item xs={6} sm={4}>
                        <TextField
                          fullWidth
                          label="Expiration Date"
                          placeholder="YYYY-MM"
                          {...register1("expirationDate", {
                            required: "Expiration date is required",
                            pattern: {
                              value: /^\d{4}-(0[1-9]|1[0-2])$/,
                              message: "Invalid format (YYYY-MM)",
                            },
                          })}
                          error={!!errors1.expirationDate}
                          helperText={errors1.expirationDate?.message}
                          disabled={loader}
                          onKeyUp={() => trigger1("expirationDate")}
                        />
                      </Grid>
                      {/* CVV */}
                      <Grid item xs={6} sm={4}>
                        <TextField
                          fullWidth
                          label="CVV/CVC"
                          placeholder="XXX"
                          {...register1("cvv", {
                            required: "CVV is required",
                            pattern: {
                              value: /^\d{3}$/,
                              message: "CVV must be 3 digits",
                            },
                          })}
                          error={!!errors1.cvv}
                          helperText={errors1.cvv?.message}
                          onKeyUp={() => trigger1("cvv")}
                          disabled={loader}
                          inputProps={{ maxLength: 3 }}
                        />
                      </Grid>

                      {/* Card Preview */}
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ maxHeight: "500px", maxWidth: "600px" }}>
                          <Card sx={{ borderRadius: 2, boxShadow: 3, position: "relative" }}>
                            <CardContent
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                padding: 2,
                                background: "radial-gradient(circle, rgba(170, 168, 168, 0.1) 10%, rgba(107, 105, 105, 0.2) 50%, rgba(151, 150, 150, 0.7) 80%)",
                                position: "relative",
                                borderRadius: 2,
                                overflow: "hidden",
                              }}
                            >
                              {/* <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                  {NameOnCard ? NameOnCard : "Your Name"}
                                </Typography>
                                <IconFingerprint />
                              </Box> */}

                              <Box sx={{ marginTop: 2 }}>
                                <Typography variant="body2" sx={{ fontSize: 10 }}>
                                  Card Number
                                </Typography>
                                <Typography variant="h5" sx={{ letterSpacing: "0.1em" }}>
                                  **** **** **** {CardNumber ? CardNumber.slice(-4) : ""}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginTop: 2,
                                }}
                              >
                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                  <Typography variant="body2" sx={{ fontSize: 8 }}>
                                    Expiry Date
                                  </Typography>
                                  <Typography variant="h6">
                                    {Expire ? Expire : "MM/YY"}
                                  </Typography>
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                  <Typography variant="body2" sx={{ fontSize: 8 }}>
                                    CVV
                                  </Typography>
                                  <Typography variant="h6">
                                    {Cvv ? Cvv : "123"}
                                  </Typography>
                                </Box>
                              </Box>
                            </CardContent>
                          </Card>
                        </Box>
                      </Grid>
                    </Grid>

                    {/* Buttons */}
                  </Card>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      m: 2,
                      gap: 2,
                    }}>
                    <Button variant="outlined" color="secondary" onClick={() => navigate('/plans')} sx={{ backgroundColor: "crimson" }} disabled={loader}>
                      Cancel
                    </Button>
                    <Button variant="contained" color="primary" type="submit">
                      {loader ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        <>
                          Save                    </>
                      )}
                    </Button>
                  </Box>
                </Grid>

              </Grid>
            </form>
          </CardContent>
        </Card>
        <Dialog
          open={successpopup}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              setsuccesspopup(false);
            }
          }}
          aria-labelledby="success-dialog-title"
          aria-describedby="success-dialog-description"
          maxWidth="sm"
          fullWidth
        >
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "5px", gap: 1 }}>
              <IconCircleCheck size={80} color="#7a5afc" />
              <Box>
                <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "600", fontSize: "2rem", color: '#7a5afc' }} >
                  Success!
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "500", fontSize: "1rem" }}>
                  Your subscription has been successfully upgraded
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              sx={{
                backgroundColor: "#7a5afc",
                color: "white",
                "&:hover": {
                  backgroundColor: "#5d1ac0",
                },
                textTransform: "none",
              }}
              onClick={() => { setsuccesspopup(false); navigate('/plans') }}
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={Errorpopup}   maxWidth="xs" fullWidth>
                <DialogTitle  sx={{display: "flex", 
                        alignItems: "center", 
                        justifyContent: "space-between", 
                        fontWeight: "bold", 
                    }}
                >
                    <Typography>Payment Failed</Typography>
                    <IconX sx={{ fontSize: 30, ml: 1 }} onClick={()=>setErrorpopup(false)} /> 
                </DialogTitle>
                <Divider/>
                <Box display="flex" justifyContent="center" alignItems="center">
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    backgroundColor: '#fff3cd',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50%',
                                    mt:1
                                }}
                            >
                                <IconAlertTriangle size={32} color="#ff9800" />
                            </Box>
                        </Box>
                    <DialogContent sx={{ textAlign: "center", p: 3 }}>
                        <Typography variant="body1">
                            {ErrorMessage || "Transaction has been failed"}
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                        <Button variant="contained" color="error" onClick={() => setErrorpopup(false)}>
                            Close
                        </Button>
                    </DialogActions>
                 </Dialog>
      </PageContainer>
    </>
  );
};

export default Billing;
